import { render, staticRenderFns } from "./SButtonBack.vue?vue&type=template&id=e32c2302&scoped=true"
import script from "./sButtonBack.ts?vue&type=script&lang=ts&external"
export * from "./sButtonBack.ts?vue&type=script&lang=ts&external"
import style0 from "./SButtonBack.vue?vue&type=style&index=0&id=e32c2302&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32c2302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e32c2302')) {
      api.createRecord('e32c2302', component.options)
    } else {
      api.reload('e32c2302', component.options)
    }
    module.hot.accept("./SButtonBack.vue?vue&type=template&id=e32c2302&scoped=true", function () {
      api.rerender('e32c2302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-button-back/SButtonBack.vue"
export default component.exports